import { render, staticRenderFns } from "./PageScroller.vue?vue&type=template&id=4e7a1540&scoped=true&lang=pug&"
import script from "./PageScroller.vue?vue&type=script&lang=js&"
export * from "./PageScroller.vue?vue&type=script&lang=js&"
import style0 from "./PageScroller.vue?vue&type=style&index=0&id=4e7a1540&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a1540",
  null
  
)

export default component.exports